
import { supabase } from '../supabaseClient';

export interface ForfeoReserveAccommodationMapping {
  accommodationId: string;
  label: string;
  active: boolean;
  catalogItemId: string;
  resourceId: string;
  calendarId: string;
}

export interface ForfeoReserveInventorySyncResult {
  authority: 'RESERVE';
  businessId: string;
  calendarId: string;
  timezone: string;
  sourceSystem: 'forfeo_accommodations';
  items: ForfeoReserveAccommodationMapping[];
  synced: number;
}

export async function syncForfeoReserveAccommodationInventory(input: {
  businessId: string;
  accommodationId?: string;
  timezone?: string;
}): Promise<ForfeoReserveInventorySyncResult> {
  const { data, error } = await supabase.functions.invoke('reserve-inventory-sync', {
    body: {
      businessId: input.businessId,
      accommodationId: input.accommodationId,
      timezone: input.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  });

  if (error) throw new Error(error.message || 'reserve_inventory_sync_failed');
  if (!data?.ok) throw new Error(String(data?.error || 'reserve_inventory_sync_failed'));
  return data as ForfeoReserveInventorySyncResult;
}
